export enum MapActionNames {
  SET_OPEN_POPUP = 'SET_OPEN_POPUP',
  SET_ZOOM_LEVEL = 'SET_ZOOM_LEVEL',
  SHUTDOWN_MAP = 'SHUTDOWN_MAP',
  CHANGE_MAP_TYPE = 'CHANGE_MAP_TYPE',
  CHANGE_MAP_REF = 'CHANGE_MAP_REF',
  CHANGE_MAP_TRAFFIC = 'CHANGE_MAP_TRAFFIC',
  CHANGE_MAP_LICENSE_PLATE = 'CHANGE_MAP_LICENSE_PLATE',
  CHANGE_DRAW_LAYERS = 'CHANGE_DRAW_LAYERS',
  CHANGE_MAP_STYLE = 'CHANGE_MAP_STYLE',
}
